import "./App.css";
import NavRoutes from "./routes/NavRoutes";
import {ToasterWrapper} from "./utils/ToastWrapper";

function App() {
  return (
    <>
     <ToasterWrapper/>
    <NavRoutes/>
  </>
  );
}

export default App;
